import { ECookiesActionTypes, TSetFullscreenBannerByCookie } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setFullscreenBannerByCookie: () => TSetFullscreenBannerByCookie =
  actionGenerator<ECookiesActionTypes.SetFullscreenBannerByCookie>(ECookiesActionTypes.SetFullscreenBannerByCookie);
